'use client'
import styles from './StandardHeroBannerBlock.module.scss'
import PageGutter from '@/src/components/common/PageGutter'
import { Block_Standard_Hero_Banner } from '@/src/generated/graphql'
import CTAButton from '@/src/components/common/CTAButton'
import DirectusImage from '@/src/components/common/DirectusImage'
import { classNames } from '@/src/helpers/component'
import WysiwygContent from '@/src/components/common/WysiwygContent'
import SearchText from '@/src/components/common/SearchText'
import { useSearchParams } from 'next/navigation'
import { setSearchParamValue } from '@/src/helpers/url'
import { useState } from 'react'

export default function StandardHeroBannerBlockClient(_: Block_Standard_Hero_Banner) {
  const searchParams = useSearchParams()
  const [search, setSearch] = useState(searchParams?.get('search') ?? '')

  const handleSearchChange = (search: string) => {
    setSearch(search)
    history.replaceState({}, '', setSearchParamValue('search', search))
    window.dispatchEvent(new CustomEvent('search-text-change', { detail: search }))
  }

  return (
    <div className={classNames('--block-standard-hero-banner', styles.container)}>
      <PageGutter className={styles.gutterContent}>
        <div className={styles.leftContent}>
          {(_.heading || _.subheading) && (
            <div className={styles.headingContainer}>
              {_.heading && <h1 className={styles.heading}>{_.heading}</h1>}
              {_.content && <WysiwygContent content={_.content} className={styles.content} />}
            </div>
          )}

          {_.cta_button && <CTAButton className={styles.cta} {..._.cta_button} />}

          {_.articles_search && (
            <SearchText
              value={search}
              onClear={() => handleSearchChange('')}
              onChange={e => {
                handleSearchChange(e.target.value)
              }}
            />
          )}
        </div>

        <div className={styles.rightContent}>
          {_.image && (
            <DirectusImage directusFile={_.image} className={styles.image} fetchPriority="high" />
          )}
        </div>
      </PageGutter>
    </div>
  )
}
